import { z } from "zod";
import { baseEntitySchema } from "./base";

export enum UserRoles {
  FULL_ACCESS = "full_access",
  ADMIN = "admin",
  OPS_MANAGER = "ops_manager",
  CS_AGENT = "cs_agent",
  FINANCE = "finance",
  READ_ONLY = "read_only",
}

export const userDataSchema = z.object({
  email: z.string().email(),
  roles: z.array(z.nativeEnum(UserRoles)),
});

export type UserData = z.infer<typeof userDataSchema>;
export const userSchema = baseEntitySchema.merge(userDataSchema);
export type User = z.infer<typeof userSchema>;
